import { downloadCSV } from '@helpers/downloadCSV';
import { getAmericanTime } from '@helpers/getAmericanTimezone';
import type { AdminWorkspaceListItemWithOrganizationResponseDto } from 'app/API';

const headers = ['ID', 'Name', 'URL', 'Organization', 'Created'];

type TWorkspaceCsvData = Pick<
  AdminWorkspaceListItemWithOrganizationResponseDto,
  'id' | 'name' | 'slug' | 'createdAt' | 'Organization'
>;

export const downloadWorkspacesCsv = (workspaces: TWorkspaceCsvData[]) => {
  const array = workspaces.map((data) => ({
    id: data.id,
    name: data.name,
    url: data.slug,
    organization: data.Organization.name,
    created: getAmericanTime(data.createdAt),
  }));
  return downloadCSV(array, headers);
};
